import apps from '@hw-ui/unused/apps/routes'
import comps from '@hw-ui/unused/components/routes'
import pages from '@hw-ui/unused/pages/routes'

const unused = [...apps,...comps, ...pages]

export default unused